import _defineProperty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useCallback, useMemo, useContext } from 'react';
import { useWarzoneStatus } from './warzone-status.js';
import { useUpdater } from '../../../hooks/use-updater.js';
var initialState = {
  loading: true,
  mapData: {},
  oldMapData: {},
  adjacencyMap: {},
  activeFactions: [],
  selectedSystem: void 0,
  setSelectedSystem: function setSelectedSystem() {}
};
var WarzoneMapContext = createContext(initialState);
var WarzoneMapProvider = function WarzoneMapProvider(_ref) {
  var initialData = _ref.data,
    updateFunc = _ref.updateFunc,
    updateInterval = _ref.updateInterval,
    children = _ref.children;
  var _useUpdater = useUpdater(initialData, updateFunc, updateInterval),
    _useUpdater2 = _slicedToArray(_useUpdater, 3),
    mapData = _useUpdater2[0],
    oldMapData = _useUpdater2[1],
    loading = _useUpdater2[2].loading;
  var _useWarzoneStatus = useWarzoneStatus(),
    statusData = _useWarzoneStatus.statusData;
  var _useState = useState(void 0),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var setSelectedSystem = useCallback(function (id) {
    return setSelected(id);
  }, []);
  var jumpMap = useMemo(function () {
    return mapData ? mapData.jumps.reduce(function (obj, _ref2) {
      var _objectSpread2;
      var from = _ref2.from,
        to = _ref2.to;
      return _objectSpread(_objectSpread({}, obj), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, from.sol, [].concat(_toConsumableArray(obj[from.sol] || []), [to.sol])), _defineProperty(_objectSpread2, to.sol, [].concat(_toConsumableArray(obj[to.sol] || []), [from.sol])), _objectSpread2));
    }, {}) : {};
  }, [mapData]);
  var mapMySystemIDs = useMemo(function () {
    return _toConsumableArray(Object.keys((mapData == null ? void 0 : mapData.systems) || {}).map(function (x) {
      return parseInt(x, 10);
    }));
  }, [mapData]);
  var activeFactions = useMemo(function () {
    if (!statusData || !mapData) return [];
    var active = [];
    statusData.forEach(function (_ref3) {
      var occupierFaction = _ref3.occupierFaction,
        ownerFaction = _ref3.ownerFaction,
        solarsystemID = _ref3.solarsystemID;
      if (mapData.systems[solarsystemID] === void 0) return;
      if (active.indexOf(occupierFaction) === -1) active.push(occupierFaction);
      if (active.indexOf(ownerFaction) === -1) active.push(ownerFaction);
    });
    return active;
  }, [statusData, mapData]);
  var adjacencyMap = useMemo(function () {
    if (!mapData || !statusData) return {};
    var baseMap = Object.entries(mapData.external).reduce(function (obj, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        id = _ref5[0],
        faction = _ref5[1].reg.faction;
      return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, id, faction));
    }, {});
    var ownershipMap = statusData.reduce(function (obj, _ref6) {
      var occupierFaction = _ref6.occupierFaction,
        id = _ref6.solarsystemID;
      return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, id, occupierFaction));
    }, baseMap);
    var frontline = mapMySystemIDs.filter(function (origin) {
      var adjacent = jumpMap[origin] || [];
      var faction = ownershipMap[origin] || void 0;
      return adjacent.map(function (x) {
        return ownershipMap[x] || void 0;
      }).filter(function (owner) {
        return owner !== void 0 && activeFactions.indexOf(owner) !== -1;
      }).some(function (owner) {
        return owner !== faction;
      });
    });
    var secondline = mapMySystemIDs.filter(function (id) {
      return frontline.indexOf(id) === -1;
    }).filter(function (id) {
      return (jumpMap[id] || []).some(function (adj) {
        return frontline.indexOf(adj) !== -1;
      });
    });
    return Object.fromEntries(mapMySystemIDs.map(function (id) {
      var status = "backline";
      if (frontline.indexOf(id) !== -1) status = "frontline";
      if (secondline.indexOf(id) !== -1) status = "secondline";
      return [id, status];
    }));
  }, [jumpMap, mapData, statusData, mapMySystemIDs, activeFactions]);
  var value = {
    mapData: mapData,
    oldMapData: oldMapData,
    adjacencyMap: adjacencyMap,
    loading: loading,
    activeFactions: activeFactions,
    selectedSystem: selected,
    setSelectedSystem: setSelectedSystem
  };
  return /* @__PURE__ */jsx(WarzoneMapContext.Provider, {
    value: value,
    children: children
  });
};
var useWarzoneMap = function useWarzoneMap() {
  return useContext(WarzoneMapContext);
};
var useWarzoneMapSystem = function useWarzoneMapSystem(solarsystemId) {
  var state = useWarzoneMap();
  if (solarsystemId === void 0) {
    return {
      adjacency: "unknown",
      type: "undefined",
      loading: state.loading
    };
  }
  if (state.mapData.systems[solarsystemId]) {
    return {
      data: state.mapData.systems[solarsystemId],
      previousData: state.oldMapData.systems[solarsystemId],
      adjacency: state.adjacencyMap[solarsystemId],
      type: "system",
      loading: state.loading,
      isSelected: state.selectedSystem === solarsystemId
    };
  }
  return {
    data: state.mapData.external[solarsystemId],
    previousData: state.oldMapData.external[solarsystemId],
    adjacency: state.adjacencyMap[solarsystemId],
    type: "external",
    loading: state.loading,
    isSelected: state.selectedSystem === solarsystemId
  };
};
export { WarzoneMapProvider, useWarzoneMap, useWarzoneMapSystem };